import { Box, SvgIcon } from '@mui/material';
import { orange } from '@mui/material/colors';

export const ConnectionLostIcon = (props) => {
  return (
    <Box
      sx={{
        width: props.sx?.width || 14,
        height: props.sx?.height || 14,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: orange[800],
        borderRadius: '50%',
      }}
    >
      <SvgIcon {...props}>
        <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.98695 4.54902L12.3511 13.8886L13.0133 13.2282L3.64909 3.88861L2.98695 4.54902ZM2.33446 7.4408C2.8253 6.95124 3.36398 6.53848 3.9355 6.20252L4.62264 6.88786C4.1718 7.13226 3.74197 7.42914 3.34217 7.77853L8 12.3307L9.05048 11.3041L9.71265 11.9645L8 13.6383L2 7.77436L2.33446 7.4408ZM12.6579 7.77853L10.3882 9.99668L11.0504 10.6571L14 7.77436L13.6656 7.4408C11.5327 5.31355 8.49655 4.63631 5.78857 5.4091L6.56212 6.18061C8.6716 5.74604 10.9415 6.27867 12.6579 7.77853Z"
            fill="white"
          />
        </svg>
      </SvgIcon>
    </Box>
  );
};
